import { CommunicationProps } from "./Communication";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuList from "@mui/material/MenuList";
import Chip from "@mui/material/Chip";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import MediumSettings from "../../models/config/CommunicationSettings/MediumSettings";
import MessageSettings from "../../models/config/CommunicationSettings/MessageSettings";

interface MessageContentForLangProps extends CommunicationProps {
    lang: keyof MediumSettings;
    medium:  keyof MessageSettings;
}

const MessageContentForLang = (props:MessageContentForLangProps) => {
    const message = props.communication?.properties?.message;

    const mediumSettings = message ? message[props.medium] : undefined;

    const mediumSettingsForThisLang  = mediumSettings ? mediumSettings[props.lang] : undefined;

    const subject = mediumSettingsForThisLang?.subject
    const body = mediumSettingsForThisLang?.body
    const messageText = mediumSettingsForThisLang?.text

    return (        <>
        <div style={{ padding: "10px", display: "flex" }}>
          
         </div>
         {props.medium as string === 'email' && <div style={{ padding: "10px" }}>
           {/* SUBJECT */}
           <TextField
             sx={{ width: "99%" }}
             id="outlined-required"
             label="Subject"
             value={subject}
             defaultValue={subject}
             onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
               if (props.handleUpdateCommunication) {
                 props.handleUpdateCommunication(
                   "subject",
                   props.communication.id,
                   event.target.value,
                   props.medium,
                   props.lang + ""
                 );
               }
             }}
           />
         </div>}
         <div style={{ padding: "10px" }}>
           {/* MESSAGE */}
           <TextField
             sx={{ width: "99%" }}
             multiline
             rows={10}
             id="outlined-required"
             label="Message"
             value={body || messageText}
             defaultValue={body || messageText}
             onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
               if (props.handleUpdateCommunication) {
                 props.handleUpdateCommunication(
                   "message",
                   props.communication.id,
                   event.target.value,
                   props.medium,
                   props.lang + ''
                 );
               }
             }}
           />
         </div>
       </>)

}

export default MessageContentForLang